import React, { FC } from 'react';
import styled from 'styled-components';
import {
  gridGap,
  GridGapProps,
  gridAutoFlow,
  gridTemplateColumns,
  gridTemplateAreas,
  gridAutoColumns,
  gridAutoRows,
  alignItems,
  // @ts-ignore
  justifyItems,
  justifyContent,
  GridAutoFlowProps,
  GridTemplatesColumnsProps,
  GridTemplatesAreasProps,
  GridAutoColumnsProps,
  GridAutoRowsProps,
  AlignItemsProps,
  JustifyItemsProps,
  JustifyContentProps,
} from 'styled-system';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { Box } from '~/components/Box';
import { Item } from './Item';

export type GridProps = typeHelpers.GetProps<typeof Box> &
  GridGapProps &
  GridAutoFlowProps &
  GridAutoFlowProps &
  GridTemplatesColumnsProps &
  GridTemplatesAreasProps &
  GridAutoColumnsProps &
  GridAutoRowsProps &
  AlignItemsProps &
  JustifyItemsProps &
  JustifyContentProps;

const GridComponent = styled(Box)<GridProps>`
  display: grid;
  ${gridGap};
  ${gridAutoFlow};
  ${gridTemplateColumns};
  ${gridTemplateAreas};
  ${gridAutoColumns};
  ${gridAutoRows};
  ${alignItems};
  ${justifyContent};
  ${justifyItems};
`;

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const GridDocz: FC<GridProps> = props => {
  return <Grid {...props} />;
};

export const Grid = Object.assign(GridComponent, {
  Item,
});

Grid.defaultProps = {
  gridGap: 'gridGap',
};
try {
    // @ts-ignore
    GridDocz.displayName = "GridDocz";
    // @ts-ignore
    GridDocz.__docgenInfo = { "description": "", "displayName": "GridDocz", "props": { "gridGap": { "defaultValue": { value: "gridGap" }, "description": "The gap CSS property sets the gaps (gutters) between rows and columns. It is a shorthand for row-gap\nand column-gap.\n@deprecated use gap\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/gap)", "name": "gridGap", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } }, "gridAutoFlow": { "defaultValue": null, "description": "The grid-auto-flow CSS property controls how the auto-placement algorithm works, specifying exactly\nhow auto-placed items get flowed into the grid.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/grid-auto-flow)", "name": "gridAutoFlow", "required": false, "type": { "name": "ResponsiveValue<string>" } }, "gridTemplateColumns": { "defaultValue": null, "description": "The grid-template-columns CSS property defines the line names and track sizing functions of the grid columns.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns)", "name": "gridTemplateColumns", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } }, "gridTemplateAreas": { "defaultValue": null, "description": "The grid-template-areas CSS property specifies named grid areas.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-areas)", "name": "gridTemplateAreas", "required": false, "type": { "name": "ResponsiveValue<string>" } }, "gridAutoColumns": { "defaultValue": null, "description": "The grid-auto-columns CSS property specifies the size of an implicitly-created grid column track.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/grid-auto-columns)", "name": "gridAutoColumns", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } }, "gridAutoRows": { "defaultValue": null, "description": "The grid-auto-rows CSS property specifies the size of an implicitly-created grid row track.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/grid-auto-rows)", "name": "gridAutoRows", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } }, "alignItems": { "defaultValue": null, "description": "The CSS align-items property sets the align-self value on all direct children as a group. The align-self\nproperty sets the alignment of an item within its containing block.\n\nIn Flexbox it controls the alignment of items on the Cross Axis, in Grid Layout it controls the alignment\nof items on the Block Axis within their grid area.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items)", "name": "alignItems", "required": false, "type": { "name": "ResponsiveValue<string>" } }, "justifyItems": { "defaultValue": null, "description": "The CSS justify-items property defines the default justify-self for all items of the box, giving them all\na default way of justifying each box along the appropriate axis.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-items)", "name": "justifyItems", "required": false, "type": { "name": "ResponsiveValue<string>" } }, "justifyContent": { "defaultValue": null, "description": "The CSS justify-content property defines how the browser distributes space between and around content items\nalong the main-axis of a flex container, and the inline axis of a grid container.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content)", "name": "justifyContent", "required": false, "type": { "name": "ResponsiveValue<string>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Grid/Grid.tsx#GridDocz"] = { docgenInfo: GridDocz.__docgenInfo, name: "GridDocz", path: "src/components/Grid/Grid.tsx#GridDocz" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    Grid.displayName = "Grid";
    // @ts-ignore
    Grid.__docgenInfo = { "description": "", "displayName": "Grid", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Grid/Grid.tsx#Grid"] = { docgenInfo: Grid.__docgenInfo, name: "Grid", path: "src/components/Grid/Grid.tsx#Grid" };
}
catch (__react_docgen_typescript_loader_error) { }